"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGen = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var formik_1 = require("formik");
var lodash_1 = __importDefault(require("lodash"));
var react_1 = require("react");
var FormGenInner = function (_a) {
    var wrapperClassNames = _a.wrapperClassNames, HeaderElement = _a.HeaderElement, preFooterElement = _a.preFooterElement, FooterElement = _a.FooterElement, FormElement = _a.FormElement, onSubmitValidationFailed = _a.onSubmitValidationFailed;
    var formik = (0, formik_1.useFormikContext)();
    return ((0, jsx_runtime_1.jsxs)("form", { className: wrapperClassNames, noValidate: true, onSubmit: function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var errors, errorKeys, touchedUpdates;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, formik.validateForm()];
                    case 1:
                        errors = _a.sent();
                        errorKeys = Object.keys(errors);
                        if (errorKeys.length > 0) {
                            touchedUpdates = errorKeys.reduce(function (acc, key) {
                                acc[key] = true;
                                return acc;
                            }, {});
                            formik.setTouched(__assign(__assign({}, formik.touched), touchedUpdates), true);
                            onSubmitValidationFailed === null || onSubmitValidationFailed === void 0 ? void 0 : onSubmitValidationFailed();
                            return [2 /*return*/];
                        }
                        formik.handleSubmit(e);
                        return [2 /*return*/];
                }
            });
        }); }, children: [HeaderElement, (0, jsx_runtime_1.jsx)(FormElement, {}), preFooterElement, FooterElement] }));
};
var FormGen = function (props) {
    var form = props.form, initialValues = props.initialValues, onSubmit = props.onSubmit, wrapperClassNames = props.wrapperClassNames, HeaderElement = props.HeaderElement, preFooterElement = props.preFooterElement, FooterElement = props.FooterElement, onSubmitValidationFailed = props.onSubmitValidationFailed;
    var _a = (0, react_1.useState)(null), init = _a[0], setInit = _a[1];
    (0, react_1.useEffect)(function () {
        var metaInitClone = lodash_1.default.cloneDeep(form.meta.initValues);
        var initClone = lodash_1.default.cloneDeep(initialValues);
        setInit(lodash_1.default.merge(metaInitClone, initClone || {}));
    }, [form.meta.initValues, initialValues]);
    if (!init)
        return (0, jsx_runtime_1.jsx)("span", {});
    var FormElement = form.Element;
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { enableReinitialize: true, initialValues: init, validationSchema: form.meta.validateSchema, onSubmit: onSubmit, children: (0, jsx_runtime_1.jsx)(FormGenInner, { wrapperClassNames: wrapperClassNames, HeaderElement: HeaderElement, preFooterElement: preFooterElement, FooterElement: FooterElement, FormElement: FormElement, onSubmitValidationFailed: onSubmitValidationFailed }) }));
};
exports.FormGen = FormGen;
